<template>
	<n-input-number
		v-model:value="modelValue"
		:min
		:max
		:step
		:placeholder
		:input-props="{ type: 'text', inputmode: 'numeric', pattern: '[0-9]*' }"
		:size
		class="w-full"
	>
		<template #prefix>
			{{ prefixText }}
		</template>
		<template #suffix>
			<div v-if="showHoursFormat && hoursFormatText" class="text-tertiary text-sm">{{ hoursFormatText }}</div>
		</template>
	</n-input-number>
</template>

<script setup lang="ts">
import type { I18nString } from "@/lang/config"
import { NInputNumber } from "naive-ui"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

const props = withDefaults(
	defineProps<{
		placeholder?: string
		prefix?: string
		min?: number
		max?: number
		step?: number
		size?: "small" | "medium" | "large"
		showHoursFormat?: boolean
	}>(),
	{
		min: 15,
		step: 15,
		showHoursFormat: true
	}
)

const modelValue = defineModel<number | null>({ default: null })

const { t } = useI18n()

const prefixText = computed(() => props.prefix ?? t<I18nString>(`appointments.form.fields.minutes`))

const hoursFormatText = computed(() => {
	const value = modelValue.value
	if (value === null || value < 60) return ""

	const hours = Math.floor(value / 60)
	const minutes = value % 60

	if (minutes === 0) return `(${hours}h)`
	return `(${hours}h ${minutes}m)`
})
</script>
